<template>
  <v-footer app class="footer" height="30">
    <v-layout justify-center row wrap>
      <span v-html="copyrightText"></span>
    </v-layout>
    <span style="float: right; padding-right: 12px;">Version {{ version }}</span>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    copyrightText: function () {
      return 'Copyright &copy; ' + new Date().getFullYear() + ' Calasdo&nbsp;&nbsp;-&nbsp;&nbsp;All rights reserved'
    },
    version: function () {
      return '1.5.0'
    }
  }
}
</script>

<style scoped>
  .footer {
    min-height: 30px;
    z-index: 1100;
  }
  .footer span {
    color: white;
    font-size: 8pt;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue